import type { CalendarEntry } from 'owa-graph-schema';

export const getEffectiveRightsString = (calendar: CalendarEntry | undefined): string => {
    if (!calendar) {
        return 'NONE';
    }
    const effectiveRightsLog: string[] = [];

    // Check each property and add it to the array if it's true
    if (
        calendar.EffectiveRights?.CreateContents ||
        ('CanCreateContents' in calendar && calendar.CanCreateContents)
    ) {
        effectiveRightsLog.push('CreateContents');
    }
    if (
        calendar.EffectiveRights?.ManageCategories ||
        ('CanManageCategories' in calendar && calendar.CanManageCategories)
    ) {
        effectiveRightsLog.push('ManageCategories');
    }
    if (
        calendar.EffectiveRights?.Read ||
        ('IsReadOnly' in calendar && calendar.IsReadOnly) ||
        ('CanCreateContents' in calendar && calendar.CanCreateContents)
    ) {
        effectiveRightsLog.push('Read');
    }
    if (
        calendar.EffectiveRights?.ViewPrivateItems ||
        ('CanViewPrivateItems' in calendar && calendar.CanViewPrivateItems)
    ) {
        effectiveRightsLog.push('ViewPrivateItems');
    }

    // Join the rights with a pipe character and return, or return "None" if the array is empty
    return effectiveRightsLog.length > 0 ? effectiveRightsLog.join('|') : 'None';
};
